import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { RestService, SessionService } from "@recore-solutions/nstar-lib";
import { environment } from "src/environments/environment";
import { UrlResponse } from "../interfaces/url-response";
import { HttpParams } from "@angular/common/http";
import { AdBuilderCampaign } from "../interfaces/AdBuilderCampaign";

@Injectable({
	providedIn: "root",
})
export class UrlService {
	postcardmaniaUrlEndpoint = environment.endpoints.postcardmaniaUrl;
	wellcomematUrlEndpoint = environment.endpoints.wellcomematUrl;
	adbuilderUrlEndpoint = environment.endpoints.adbuilderUrl;
	spherebuilderUrlEndpoint = environment.endpoints.spherebuilderUrl;
	adbuilderCampaignsEndpoint = environment.endpoints.adbuilderCampaigns;

	constructor(private rest: RestService, private sessionService: SessionService) {}

	getPostcardmnaiaUrl(): Observable<UrlResponse> {
		return this.rest.get<UrlResponse>([this.postcardmaniaUrlEndpoint], null);
	}

	getSpherebuilderUrl(): Observable<UrlResponse> {
		return this.rest.get<UrlResponse>([this.spherebuilderUrlEndpoint], null);
	}

	getWellcomematUrl(): Observable<string> {
		return this.rest
			.get<UrlResponse>([this.wellcomematUrlEndpoint], null)
			.pipe(map((response) => response.url));
	}

	getAdBuilderCampaigns(listingSks: string): Observable<AdBuilderCampaign[]> {
		const loggedInAgent = this.sessionService.userBasics.memberReference;
		const httpParams = new HttpParams({
			fromObject: {
				"listing-sks": listingSks,
			},
		});
		return this.rest
			.get<AdBuilderCampaign[]>([this.adbuilderCampaignsEndpoint], httpParams)
			.pipe(
				map((campaigns: AdBuilderCampaign[]) =>
					campaigns.filter((campaign) => campaign.MemberKey === loggedInAgent)
				)
			);
	}

	getAdbuilderUrl(listingSk: number): Observable<UrlResponse> {
		const httpParams = new HttpParams({
			fromObject: {
				"listing-sk": listingSk,
			},
		});
		return this.rest.get<UrlResponse>([this.adbuilderUrlEndpoint], httpParams);
	}
}
